/**
 * 市场调研卡片组件
 */

import React from 'react';
import { Card, Form, Row, Col, Input, Select } from 'antd';
import { MARKET_SIZE_OPTIONS, MARKET_TREND_OPTIONS } from './constants';

const { TextArea } = Input;

export const MarketResearchCard: React.FC = () => {
    return (
        <Card title="📊 市场调研" bordered={false}>
            <Row gutter={24}>
                <Col span={12}>
                    <Form.Item
                        name={['research_data', 'market_size']}
                        label="市场规模"
                    >
                        <Select
                            options={MARKET_SIZE_OPTIONS as any}
                            placeholder="选择市场规模"
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name={['research_data', 'market_trend']}
                        label="市场趋势"
                    >
                        <Select
                            options={MARKET_TREND_OPTIONS as any}
                            placeholder="选择市场趋势"
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name={['research_data', 'market_analysis']}
                        label="市场分析"
                    >
                        <TextArea
                            rows={4}
                            placeholder="描述市场现状、趋势、机会等..."
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};

export default MarketResearchCard;
